import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Modal } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import ProfilePageLayout from "../../profile/ProfilePageLayout/ProfilePageLayout";
import EmailSentComponent from "../LoginForm/EmailSent";
import { ForgotPasswordForm } from "../LoginForm/ForgotPasswordOptions";
import LoginForm from "../LoginForm/LoginForm";
import {
  dropdown,
  profile,
  profileModal,
  travelPassLogo,
} from "./SignInBar.module.scss";

export const TravelPassLogo: React.FC = () => {
  return (
    <div className={travelPassLogo}>
      <svg className="logo" id="travel-pass-logo">
        <use xlinkHref="/svg/travel-pass-new-logo.svg#travel-pass-new-logo">
          {" "}
        </use>
      </svg>
    </div>
  );
};

interface ModalHeaderProps {
  onBackClick: () => void | undefined;
  onCloseClick: () => void;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  onBackClick,
  onCloseClick,
}) => {
  return (
    <>
      <div className="modal-header-container">
        {onBackClick ? (
          <svg
            className="back-icon"
            onClick={onBackClick}
            tabIndex={0}
            role="button"
            aria-label="Back to sign in"
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                onBackClick();
                e.preventDefault();
              }
            }}
          >
            <use xlinkHref="/svg/chevron_left.svg#chevron_left"></use>
          </svg>
        ) : (
          <div className="spacer"></div>
        )}
        <svg className="logo-icon">
          <use xlinkHref="/svg/travel-pass-new-logo.svg#travel-pass-new-logo"></use>
        </svg>
        <svg
          className="close-icon"
          tabIndex={0}
          onClick={onCloseClick}
          role="button"
          aria-label="Close sign in"
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              onCloseClick();
              e.preventDefault();
            }
          }}
        >
          <use xlinkHref="/svg/close.svg#close"></use>
        </svg>
      </div>
      <div className="divider"></div>
    </>
  );
};
export const StyledDropdown: React.FC<any> = (props) => {
  return (
    <Dropdown className={dropdown} {...props}>
      {props.children}
    </Dropdown>
  );
};

export const DropdownLoginForm: React.FC<any> = (props) => {
  const [currentForm, setCurrentForm] = React.useState<
    "login" | "forgotPassword" | "emailSent"
  >("login");
  // const [emailMessage, setEmailMessage] = React.useState("");
  const handleForgotPassword = () => {
    setCurrentForm("forgotPassword");
  };

  return (
    <>
      <ModalHeader onCloseClick={props.onCloseClick} />
      <div className="login-form-wrapper">
        {currentForm === "login" && (
          <LoginForm onForgotPassword={handleForgotPassword} {...props} />
        )}
      </div>
    </>
  );
};

export const DropdownToggleIcon: React.FC<any> = () => {
  return (
    <FontAwesomeIcon
      className="toggle-icon"
      icon={faChevronDown}
      style={{ fontSize: "10px" }}
    />
  );
};

export const Profile: React.FC<any> = (props) => {
  return <div className={profile}>{props.children}</div>;
};

export const ProfileModal: React.FC<any> = (props) => {
  return (
    <Modal
      className={profileModal}
      show={props.show}
      onHide={props.onHide}
      id="profile-modal"
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <ProfilePageLayout />
      </Modal.Body>
    </Modal>
  );
};
